import SearchModalNoResults from './SearchModalNoResults';

export default SearchModalNoResults;
